<template>
  <v-row>
    <v-dialog v-model="showDialog" scrollable max-width="850px">
      <v-card>
        <v-card-title>
          <v-panel>
            <span style="font-size: 20px;">
              {{ $t("wkt.admin.training-action.edit-window.add-enrollment") }}
            </span>
          </v-panel>
        </v-card-title>
        <v-card-text @wheel="onWheel">
          <v-container>
            <v-form ref="form">
              <v-row>
                <v-col cols="12">
                  <v-autocomplete
                    v-model="employeeIds"
                    :items="employees"
                    :item-text="getEmployeeText"
                    item-value="id"
                    :label="$t('wkt.admin.training-enrollment-batch.window.workers')"
                    multiple
                    chips
                    deletable-chips
                    :disabled="isReadOnly"
                    :menu-props="trainingEnrollmentBatchDialogMenuProps"
                    clearable
                  />
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12">
                  <v-textarea
                    v-model="observations"
                    :label="$t('wkt.admin.training-enrollment.edit-window.observations')"
                    auto-grow
                    rows="3"
                    maxlength="2000"
                    counter="2000"
                    :disabled="isReadOnly"
                  />
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12">
                  <span style="color: #757575; font-size: 13px;">
                    {{ $t("wkt.admin.training-enrollment-batch.window.note") }}
                  </span>
                </v-col>
              </v-row>
            </v-form>
          </v-container>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="#185EA9"
            text
            @click="onSave()"
            style="font-size: 0.9em; font-weight: 400;"
            :disabled="isReadOnly"
          >
            {{ $t("wkt.admin.common.dialog-buttons.ok").toUpperCase() }}
          </v-btn>
          <v-btn
            text
            @click="showDialog = false"
            style="font-size: 0.9em; font-weight: 400;"
          >
            {{ $t("wkt.admin.common.dialog-buttons.cancel").toUpperCase() }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
import BaseModule from "../../common/BaseModule.js";

export default {
  name: "TrainingEnrollmentBatchDialog",
  mixins: [BaseModule],
  data() {
    return {
      showDialog: false,
      isReadOnly: false,
      employees: [],
      trainingEnrollmentBatchDialogMenuProps: {
        zIndex: 260,
        contentClass: "training-enrollment-batch-dialog-menu",
      },
      trainingAction: null,
      employeeIds: [],
      observations: "",
    };
  },
  mounted() {
    this.installShadowMenuWheelPatch({
      menuSelector: ".training-enrollment-batch-dialog-menu",
      handlerKey: "__tweemTrainingEnrollmentBatchManualWheelHandler",
    });
  },
  beforeDestroy() {
    this.teardownShadowMenuWheelPatch();
  },
  methods: {
    onWheel(event) {
      if (!event) {
        return;
      }

      event.stopPropagation();
    },
    open(payload) {
      this.showDialog = true;
      this.isReadOnly = !!payload?.isReadOnly;
      this.employees = payload?.employees || [];
      this.trainingAction = payload?.trainingAction || null;
      this.employeeIds = [];
      this.observations = "";

      if (this.$refs.form) {
        this.$refs.form.resetValidation();
      }
    },
    getEmployeeText(item) {
      if (!item) {
        return "";
      }
      const fullName = `${item.lastname || ""}, ${item.firstname || ""}`.replace(/^,\s*/, "");
      const context = [item.departmentName, item.workplaceName].filter(Boolean).join(" - ");
      return context ? `${fullName} - ${context}` : fullName;
    },
    onSave() {
      if (!this.employeeIds || this.employeeIds.length === 0) {
        return;
      }

      this.$emit("save", {
        trainingActionId: this.trainingAction?.id || null,
        employeeIds: this.employeeIds,
        observations: this.observations,
      });
      this.showDialog = false;
    },
  },
};
</script>
